module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Thin.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Thin.ttf
// module id = 55
// module chunks = 8